<!-- src/views/SpecialView.vue -->
<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <FloorPlanCanvas />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FloorPlanCanvas from "@/components/FloorPlanCanvas.vue";

export default {
  name: "SpecialView",
  components: {
    FloorPlanCanvas,
  },
};
</script>

<style scoped>
/* Agrega estilos personalizados si es necesario */
</style>
